import { useLayoutEffect } from 'react'
import { useSystemTheme } from '../lib/theme/system-theme'
import { useThemeStore } from '../lib/stores/theme.store'

/**
 * Non-visual component. Syncs the OS color scheme into the theme store.
 * Uses useLayoutEffect so the store update happens synchronously before
 * paint — prevents any visible theme oscillation.
 */
export function ThemeBootstrap(): null {
  const systemTheme = useSystemTheme()
  const setSystemTheme = useThemeStore((s) => s.setSystemTheme)

  useLayoutEffect(() => {
    setSystemTheme(systemTheme)
  }, [systemTheme, setSystemTheme])

  return null
}
